import script from "./FinanceCosts.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceCosts.vue?vue&type=script&setup=true&lang=js"

import "./FinanceCosts.vue?vue&type=style&index=0&id=4a87bb42&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a87bb42"]])

export default __exports__